export const COLORCUSTOM = -1;
export const SWL_COLOR_BLUE = "#0064ff";
export const SWL_COLOR_BLUE_2023 = "#415FFF";
export const SWL_COLOR_GREY_INACTIVE = "#4A4A4A";
export const SWL_COLOR_GREEN_WAYPOINT = "#13FFAB";
